import React from "react";
import classnames from "classnames";

export type Colour = "white" | "grey" | "slate";

type Props = {
  children: React.ReactNode;
  colour?: Colour;
  component?: React.ElementType;
  className?: string;
};

const SmallHeading = ({
  children,
  colour = "grey",
  component = "span",
  className
}: Props) => {
  const MarkupComponent = component;

  return (
    <MarkupComponent
      className={classnames(`small-${colour}-heading`, className)}
    >
      {children}
    </MarkupComponent>
  );
};

export default SmallHeading;
